import { AlignType, StretchType } from "../../Controls/ControlEnums";
import { Margin } from "../../Helpers/Margin";
/**
* Základní element pro urceni pozicovani
*/
export class BaseAlignElement {
    //#region Fields
    private _element: HTMLElement | undefined = undefined;

    protected _width: number = 0;
    protected _height: number = 0;
    protected _top: number = 0;
    protected _left: number = 0;
    protected _alignType: AlignType = AlignType.none;
    protected _margin: Margin | null = null;

    //#endregion Fields

    //#region Properties
    public get width(): number {
        return this._width;
    }

    public get height(): number {
        return this._height;
    }

    public get top(): number {
        return this._top;
    }

    public get left(): number {
        return this._left;
    }

    public get alignType(): number {
        return this._alignType;
    }

    public get margin(): Margin | null {
        return this._margin;
    }

    public get element(): HTMLElement | undefined {
        return this._element;
    }

    public set element(v: HTMLElement | undefined) {
        this._element = v;
    }
    //#endregion Properties

    constructor(element: HTMLElement) {
        this.element = element;
        this._parseAlignData(element);
    }

    protected _parseAlignData(element: HTMLElement): void {
        this._alignType = BaseAlignElement._parseAlignType(element.getAttribute("data-align"));
        this._width = BaseAlignElement.parseNum(element.getAttribute("data-width"));
        this._height = BaseAlignElement.parseNum(element.getAttribute("data-height"));
        this._top = BaseAlignElement.parseNum(element.getAttribute("data-top"));
        this._left = BaseAlignElement.parseNum(element.getAttribute("data-left"));
        if (this._alignType != AlignType.none)
            this._margin = Margin.parse(element.getAttribute("data-margin"));
        else
            this._margin = null;
    }

    public static parseNum(num: any): number {
        try {
            const res = parseInt(num);
            if (isNaN(res))
                return 0;

            return res;
        } catch (e) {
            return 0;
        }
    }

    private static _parseAlignType(alType: string | null | undefined): AlignType {
        if (!alType)
            return AlignType.none;
        switch (alType ? alType.toLowerCase() : alType) {
            case "altop":
                return AlignType.top;
            case "albottom":
                return AlignType.bottom;
            case "alleft":
                return AlignType.left;
            case "alright":
                return AlignType.right;
            case "alclient":
                return AlignType.client;
            default:
                return AlignType.none;
        }
    }

    public static parseStretchType(alType: string | null | undefined): StretchType {
        if (!alType)
            return StretchType.none;
        switch (alType ? alType.toLowerCase() : alType) {
            case "sthorizontal":
                return StretchType.horizontal;
            case "stvertical":
                return StretchType.vertical;
            case "stboth":
                return StretchType.both;
            default:
                return StretchType.none;
        }
    }

    public getSizeCssString(offset?: { width?: number; height?: number; top?: number; left?: number }): string {
        let styleData = "";
        if (this.width != undefined)
            styleData += `width: ${offset && offset.width ? this.width + offset.width : this.width}px; `;
        if (this.height != undefined)
            styleData += `height: ${offset && offset.height ? this.height + offset.height : this.height}px; `;
        if (this.top != undefined)
            styleData += `top: ${offset && offset.top ? this.top + offset.top : this.top}px; `;
        if (this.left != undefined)
            styleData += `left: ${offset && offset.left ? this.left + offset.left : this.left}px; `;
        //if (this._margin != undefined) styleData += this._margin.toString();

        return styleData;
    }

    //#endregion Properties
}
